import React from "react";

export const NewPageLazy = React.lazy(() => import("./index"));
